import React from 'react';
import { Helmet } from 'react-helmet-async';
import { CANONICAL_BASE_URL } from '../utils/constants';
import { SEO_MAX_TITLE, SEO_MAX_DESCRIPTION } from '../utils/seoKeywords';

export interface PageSEOProps {
  title: string;
  description: string;
  keywords?: string;
  ogImage?: string;
}

/** Truncate to standard SEO lengths (Google truncates beyond these). */
const truncate = (text: string, max: number) =>
  text.length <= max ? text : text.slice(0, max - 3).trim() + '...';

/** Sets per-page title, meta description, keywords, and Open Graph tags. Canonical is set by CanonicalURL. */
const PageSEO: React.FC<PageSEOProps> = ({
  title,
  description,
  keywords,
  ogImage = `${CANONICAL_BASE_URL}/pickup-rental-truck-dubai-logo.png`,
}) => {
  const safeTitle = truncate(title, SEO_MAX_TITLE);
  const safeDescription = truncate(description, SEO_MAX_DESCRIPTION);
  return (
  <Helmet>
    <title>{safeTitle}</title>
    <meta name="description" content={safeDescription} />
    {keywords && <meta name="keywords" content={keywords} />}
    <meta property="og:title" content={safeTitle} />
    <meta property="og:description" content={safeDescription} />
    <meta property="og:image" content={ogImage} />
    <meta name="twitter:title" content={safeTitle} />
    <meta name="twitter:description" content={safeDescription} />
    <meta name="twitter:image" content={ogImage} />
  </Helmet>
  );
};

export default PageSEO;
